import { render, staticRenderFns } from "./MedicalRecords.vue?vue&type=template&id=0624b14a&scoped=true&"
import script from "./MedicalRecords.vue?vue&type=script&lang=js&"
export * from "./MedicalRecords.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecords.vue?vue&type=style&index=0&id=0624b14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0624b14a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0624b14a')) {
      api.createRecord('0624b14a', component.options)
    } else {
      api.reload('0624b14a', component.options)
    }
    module.hot.accept("./MedicalRecords.vue?vue&type=template&id=0624b14a&scoped=true&", function () {
      api.rerender('0624b14a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VideoCall/components/MedicalRecords.vue"
export default component.exports